import React from "react";

import FormAvatar from "UI/Form/FormAvatar";

function PosebnaPonudaAvatar(props) {
  return <FormAvatar ariaLabel="posebna_ponuda" icon_word="stars" />;
}

export default PosebnaPonudaAvatar;
